export class UserLoginModel {
    constructor(data: any) {
        if (data) {
            this.id = data.id;
            this.userName = data.userName;
            this.firstName = data.firstName;
            this.middle = data.middle;
            this.lastName = data.lastName;
        }
    }

    id: number;
    userName: string;
    firstName: string;
    middle: string;
    lastName: string;
}
